// 分类商品码洋对比模块
const state = {
  list: []
}

const mutations = {
  SET_DATA(state, data) {
    if (data && Array.isArray(data)) {
      state.list = data.map(item => ({
        id: item.id,
        fl: item.fl || '未分类',    // 分类名称
        orders: item.orders || 0,    // 订单数
        amount: item.amount || 0     // 码洋
      }))
    } else {
      state.list = []
    }
  },
  RESET_DATA(state) {
    state.list = []
  }
}

const getters = {
  list: state => state.list,
  // 按码洋排序
  sortedByAmount: state => {
    return [...state.list].sort((a, b) => b.amount - a.amount)
  },
  // 按订单数排序
  sortedByOrders: state => {
    return [...state.list].sort((a, b) => b.orders - a.orders)
  },
  // 总码洋
  totalAmount: state => {
    return state.list.reduce((sum, item) => sum + item.amount, 0)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
